import { DoubleChevronLeft, MoreHorizontallySmall } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';

interface Props {
  shouldRotate?: boolean;
}

export const PagerDots = ({ shouldRotate }: Props) => (
  <div className="flex justify-center tracking-wide text-neutral-60">
    <MoreHorizontallySmall className="absolute top-3 group-hover:hidden group-focus-visible:hidden" />
    <DoubleChevronLeft
      className={cn('hidden group-hover:block group-focus-visible:block', {
        'rotate-180': shouldRotate,
      })}
    />
  </div>
);
